module.exports = __webpack_public_path__ + "static/img/quanjing_001.ace1ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quanjing_001.png
// module id = kXzy
// module chunks = 1